// ...existing code...
import React, { useState } from 'react';

const ForgotPassword = ({show}) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    try {
      const res = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });

      if (res.ok) {
        setMessage('If that email exists in our system, a password reset link has been sent.');
        setEmail('');
      } else {
        const payload = await res.json().catch(() => ({}));
        setError(payload?.error || 'Failed to send reset email. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (show) {return (
    <div className="forgot-password container" style={{ maxWidth: 480, margin: '2rem auto' }}>
      <h2 style={{ marginBottom: '1rem' }}>Reset Password</h2>

      {message && (
        <div
          role="status"
          aria-live="polite"
          style={{
            padding: '0.75rem 1rem',
            marginBottom: '1rem',
            borderRadius: 6,
            background: '#e6ffed',
            color: '#065f46',
            border: '1px solid #bbf7d0',
          }}
        >
          {message}
        </div>
      )}

      {error && (
        <div
          role="alert"
          aria-live="assertive"
          style={{
            padding: '0.75rem 1rem',
            marginBottom: '1rem',
            borderRadius: 6,
            background: '#fff1f2',
            color: '#9f1239',
            border: '1px solid #fecaca',
          }}
        >
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} noValidate>
        <div style={{ marginBottom: '0.75rem' }}>
          <label htmlFor="forgot-email" style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>
            Email address
          </label>
          <input
            id="forgot-email"
            name="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            style={{
              width: '100%',
              padding: '0.5rem 0.75rem',
              borderRadius: 6,
              border: '1px solid #d1d5db',
              fontSize: '1rem',
            }}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            padding: '0.5rem 1rem',
            borderRadius: 6,
            border: 'none',
            background: '#0d6efd',
            color: '#fff',
            fontWeight: 600,
            cursor: loading ? 'default' : 'pointer',
          }}
        >
          {loading ? 'Sending…' : 'Send Reset Link'}
        </button>
      </form>
    </div>
  );
};
}; 

export default ForgotPassword;